<template>
  <div class="mt-4">
    <filter-bar @set-new-report-params="setNewReportParams"></filter-bar>
    <div class="md-layout">
      <div class="md-layout-item content">
        <report-empty-state
          v-if="hasNoReportData"
          :title="$t('attendance_report.student.empty_state_title')"
          :desc="$t('attendance_report.student.empty_state_desc')"
        ></report-empty-state>
        <template v-else>
          <student-information></student-information>
          <enrolled-classes-table
            :table-data="enrolledClasses"
          ></enrolled-classes-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FilterBar from "./FilterBar.vue";
import StudentInformation from "./Information.vue";
import EnrolledClassesTable from "./EnrolledClassesTable";
import ReportEmptyState from "@/pages/Report/Components/EmptyState.vue";
import { service_paths } from "@/constants/Services";
import { initLoader } from "@/helpers/utils";

export default {
  components: {
    FilterBar,
    StudentInformation,
    EnrolledClassesTable,
    ReportEmptyState
  },
  data() {
    return {
      path: `${service_paths.reports}/attendance`,
      reportParams: {
        student_id: null,
        program_id: null,
        term_id: null,
        class_ids: null
      },
      reportData: {
        studentInfo: null,
        attdOverview: null,
        attdPercentage: null
      }
    };
  },
  computed: {
    hasNoReportData() {
      return Object.values(this.reportParams).every(value => !value);
    },
    enrolledClasses() {
      return this.reportData.studentInfo?.classes;
    }
  },
  methods: {
    setNewReportParams(reportParams) {
      Object.keys(reportParams).forEach(key => {
        this.$set(this.reportParams, key, reportParams[key]);
      });
    },
    fetchAttdOverview() {
      return this.$axios
        .get(
          `${this.path}/overview-percentage`,
          this.reportParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.attdOverview = data;
        });
    },
    fetchAttdPercentage() {
      return this.$axios
        .get(
          `${this.path}/present-percentage`,
          this.reportParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.attdPercentage = data;
        });
    },
    fetchStudentInfo() {
      return this.$axios
        .get(
          `${this.path}/student/${this.reportParams.student_id}`,
          this.reportParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.studentInfo = data;
        });
    },
    fetchReportData() {
      const loader = initLoader();

      Promise.all([
        this.fetchAttdOverview(),
        this.fetchAttdPercentage(),
        this.fetchStudentInfo()
      ]).finally(() => loader.hide());
    }
  },
  watch: {
    reportParams: {
      deep: true,
      handler: function() {
        this.fetchReportData();
      }
    }
  },
  provide() {
    return {
      reportParams: this.reportParams,
      reportData: this.reportData
    };
  }
};
</script>

<style lang="scss" scoped>
thead tr * {
  font-weight: 600 !important;
}
</style>
